import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  order: Order;
  index?: number;
}


import { computed } from 'vue';

import { useRouter } from '@router';
import { Order } from '@models';

import DisplayTextCurrency from '@components/Display/DisplayTextCurrency.vue';
import DisplayTextDate from '@components/Display/DisplayTextDate.vue';

import OrderCardItem from './OrderCardItem.vue';

const __default__ = { name: 'OrderCard' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    order: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
  order: Order;
  index?: number;
};

/**
 * `OrderCard` component properties.
 */


const router = useRouter();

const transitionDelay = computed(() => {
  return typeof props.index !== 'number' ? null : `${0.1 * props.index}s`;
});

// const shippingInfo = computed(() => {
//   if (!props.order.isShipping) return null;

//   return {
//     first: props.order.shippingFirst,
//     last: props.order.shippingLast,
//     country: props.order.shippingCountry,
//     address1: props.order.shippingAddress1,
//     address2: props.order.shippingAddress2,
//     address3: props.order.shippingAddress3,
//     city: props.order.shippingCity,
//     stateProvince: props.order.shippingStateProvince,
//     postalCode: props.order.shippingPostalCode,
//   } as ZephyrWeb.AddressInfo;
// });

function goToOrderPage() {
  void router.push({
    name: 'orderStatus',
    params: { orderId: props.order.id },
  });
}

return { __sfc: true,props, router, transitionDelay, goToOrderPage, DisplayTextCurrency, DisplayTextDate, OrderCardItem }
}

})